import { Parm0Callback, Parm1Callback } from "@Components/app/members/teamInterfaces";
import HapticsButtonWrapper from '@Components/generic/haptics-button-wrapper';
import useI18n from "@i18n";
import { Box, Button, ButtonProps, Grid, useTheme } from '@mui/material';
import { styled } from '@mui/system';
import { FC, useState } from 'react';

const KeyButton: FC<ButtonProps> = ((props) => {
  return (
    <HapticsButtonWrapper>
      <Button variant='contained' {...props}  sx={{
        height: '65px',
        lineHeight: '70px',
        width: '70px',
        textAlign: 'center',
        verticalAlign: 'middle',
        border: '0px',
        borderRadius: '4px',
        fontFamily: 'Optician-Sans',
        fontStyle: 'normal',
        fontWeight: '400px',
        fontSize: '32px',
        // background: theme.palette.dsSurface.v200,
        ...props.sx
      }}>
        {props.children}
      </Button>
    </HapticsButtonWrapper>
    )
});

const KeyPad = styled("div")(({ }) => ({
  width: '230px', //todo : update this spacing
  marginTop: '34px',
  marginLeft: 'auto',
  marginRight: 'auto',
}));

//passin user string
const KeypadVR: FC<{
  disableKeyPad: boolean,
  onKeyPressed: Parm1Callback<string>,
  onClearPin?: Parm0Callback,
  pin: string
}> = ({ 
  disableKeyPad,
  onKeyPressed,
  onClearPin,
  pin
}) => {
  const theme = useTheme();
  const { i18n } = useI18n();
  const [hasInput, setHasInput] = useState<boolean>(false);

  let items: string[] =
    ['1', '2', '3',
      '4', '5', '6',
      '7', '8', '9',
      '0',];

  return (
      <KeyPad>
        <Grid container
          spacing={1}
          justifyContent="center"
          alignItems="center"
          position={'relative'}
        >
          {items.map(index => (
            <Grid key={index} item xs={4}>
              <KeyButton onClick={(event: any) => { setHasInput(true); onKeyPressed(index); }} disabled={disableKeyPad}>
                {index}
              </KeyButton>
            </Grid>
          ))}
          {onClearPin && <Box position={'absolute'} bottom={0} right={0}>
            <KeyButton onClick={()=> {onClearPin(); setHasInput(false);}} 
            // variant='outlined'
            disabled={pin === ''} 
            sx={{
              fontSize: theme.spacing(2), 
              border: `1px solid ${theme.palette.dsSurface.v200}`
              }}>
              {i18n('clear')}
            </KeyButton>
          </Box>}
        </Grid>
      </KeyPad >
  );
}

export default KeypadVR;
